import { createTheme } from "@mui/material/styles"
import "@fontsource/roboto" // Ensure font is imported

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
  typography: {
    fontFamily: "Roboto, sans-serif", // Set Roboto as the default font
  },
})

export default theme
